import { createSelector } from "reselect";
const selector = (state) => state.tags;

export default createSelector([selector], (data) => data);